<template>
	<div class="expiration-notification-bar" v-if="showWarning">
		<div class="close-mark" @click="dismissed = true">
			<icon class="fa-light fa-xmark"></icon>
		</div>
		<div class="pl-3">{{ $t('expiration-warning.message') }}:</div>
		<div v-if="commercialAccess && commercialAccess.modules" v-for="plan in commercialAccess.modules" :key="plan.id">
			<div v-if="isNearExpiration(plan.endDate)" class="chip ml-2">
				<div>
					<icon class="fa-light fa-triangle-exclamation"></icon>
				</div>
				<div>{{ plan.typeName }}: {{ getRemainingTime(plan.endDate) }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'

	export default {
		data() {
			return {
				dismissed: false
			}
		},
		computed: {
			...mapGetters({
				commercialAccess: 'appContext/getCommercialAccess',
			}),
			showWarning() {
				if (this.dismissed) return false
				if (!this.commercialAccess || !this.commercialAccess.modules) return false
				return this.commercialAccess.modules.some(module => this.isNearExpiration(module.endDate))
			}
		},
		mounted() {

		},
		methods: {
			getDiff(endDate) {
				return new Date(endDate) - new Date()
			},
			getRemainingTime(endDate) {
				const diff = this.getDiff(endDate)
				if (diff <= 0) return this.$t('expiration-warning.f.expired')

				const oneMinute = 1000 * 60
				const oneHour = oneMinute * 60
				const oneDay = oneHour * 24

				if (diff >= oneDay) return Math.floor(diff / oneDay) + ' ' + this.$t('expiration-warning.f.day')
				else if (diff >= oneHour) return Math.floor(diff / oneHour) + ' ' + this.$t('expiration-warning.f.hour')
				else return Math.floor(diff / oneMinute) + ' ' + this.$t('expiration-warning.f.minute')
			},
			isNearExpiration(endDate) {
				if (!endDate) return
				const msLeft = this.getDiff(endDate)
				const treshhold = (1000 * 60 * 60 * 24) * 14
				return msLeft <= treshhold
			}
		}
	}
</script>

<style lang="less">
	.expiration-notification-bar {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		text-align: center;
		background-color: red;
		color: #fff;
		padding: 10px;
	}

	.chip {
		padding: 1px 8px;
		border-radius: 20px;
		background: rgba(255, 255, 255, 0.945);
		border: 1px solid rgba(255, 255, 255, 0.25);

		color: #ff0000;
		font-size: 11px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 4px;
	}

	.close-mark {
		position: absolute;
		right: 10px;
		cursor: pointer;
	}

</style>